import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import { API_URL } from '../reusable/url';

const Register = () => {
  const [token, setToken] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, username, password }),
      credentials: 'include'
    };

    try {
      const response = await fetch(API_URL('register'), options);

      const data = await response.json();
      
      if (response.ok) {
        setSuccess(data.message);
        setError('');
        setTimeout(() => {
          navigate('/login');
        }, 2000); // Redirect to login after 2 seconds
      } else {
        setError(data.message);
        setSuccess('');
      }
    } catch (err) {
      setError('Registration error: ' + err.message);
      setSuccess('');
    }
  };

  return (
    <div className='user-registration-container'>
      <h2>Register</h2>
      <form onSubmit={handleSubmit}>
        <Box sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}>
          <TextField 
            required
            id="outlined-token-input"
            label="Token"
            type="text"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            color="secondary"
            focused
            InputLabelProps={{ style: { color: 'blue' } }}
            sx={{
              input: { color: 'navy' },
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: 'blue' },
                '&:hover fieldset': { borderColor: 'blue' },
                '&.Mui-focused fieldset': { borderColor: 'blue' },
              },
            }}
          />
          <TextField 
            required
            id="outlined-username-input"
            label="Username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            color="secondary"
            focused
            InputLabelProps={{ style: { color: 'darkviolet' } }}
            sx={{
              input: { color: 'navy' },
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: 'darkviolet' },
                '&:hover fieldset': { borderColor: 'darkviolet' },
                '&.Mui-focused fieldset': { borderColor: 'darkviolet' },
              },
            }}
          />
          <TextField 
            required
            id="outlined-password-input"
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            color="secondary"
            focused
            InputLabelProps={{ style: { color: 'darkviolet' } }}
            sx={{
              input: { color: 'navy' },
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: 'darkviolet' },
                '&:hover fieldset': { borderColor: 'darkviolet' },
                '&.Mui-focused fieldset': { borderColor: 'darkviolet' },
              },
            }}
          />
        </Box>
        <Button variant="contained" color="primary" type="submit">Register</Button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {success && <p style={{ color: 'green' }}>{success}</p>}
    </div>
  );
};

export default Register;
